/* Verona Tempo — Round 10 (A): compact menu dropdowns (click + keyboard), announcement bar arrows,
   loading line, recently viewed on empty search / page not found. See REVAMP-LOG.md "Round 10 — look (A)".
   Runs after vt-theme.js (deferred, page order) and uses window.vtCore when it is there. */
(function () {
  'use strict';
  var html = document.documentElement;
  var rtl = html.getAttribute('dir') === 'rtl';
  var onReady = function (fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  };

  /* ---- compact dropdowns (computers) ------------------------------------------------------------
     Symmetry opens the real panels (#main-nav) when the pointer is over the menu words (#proxy-nav) or on Enter.
     Here: each panel is placed under its word (--vt-dd-x, kept inside the screen), the small arrow button opens and
     closes it (click / tap / Enter / Space), Tab from an open arrow goes into the panel, Tab after the last link goes
     on to the next menu word, Esc closes and gives focus back, a click outside closes. */
  function initDropdowns() {
    if (!html.classList.contains('vt-r10-dd')) return;
    var proxy = document.getElementById('proxy-nav');
    var mainNav = document.getElementById('main-nav');
    if (!proxy || !mainNav) return;
    var proxyItems = Array.prototype.slice.call(proxy.querySelectorAll('.navigation__tier-1 > .navigation__item'));
    var realItems = Array.prototype.slice.call(mainNav.querySelectorAll('.navigation__tier-1 > .navigation__item'));
    if (!proxyItems.length || proxyItems.length !== realItems.length) return;
    var desktop = window.matchMedia('(min-width: 768px)');

    var panelOf = function (i) { return realItems[i] && realItems[i].querySelector(':scope > .navigation__tier-2-container'); };
    var place = function (i) {
      var panel = panelOf(i);
      if (!panel || !desktop.matches) return;
      var r = proxyItems[i].getBoundingClientRect();
      var w = panel.offsetWidth;
      var vw = document.documentElement.clientWidth;
      var x = rtl ? r.right + 12 - w : r.left - 12;
      x = Math.max(16, Math.min(x, vw - w - 16));
      panel.style.setProperty('--vt-dd-x', Math.round(x) + 'px');
    };
    var placeAll = function () { proxyItems.forEach(function (_, i) { place(i); }); };
    // r12: the calmer hover (assets/vt-r12.js) places the panels the same way
    window.vtR10Dd = { place: place };
    placeAll();
    window.addEventListener('resize', placeAll, { passive: true });
    window.addEventListener('load', placeAll);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(placeAll);

    var isOpen = function (i) { return realItems[i].classList.contains('navigation__item--show-children'); };
    var syncButtons = function () {
      proxyItems.forEach(function (item, i) {
        var btn = item.querySelector('.vt-dd-toggle');
        if (btn) btn.setAttribute('aria-expanded', isOpen(i) ? 'true' : 'false');
      });
    };
    // keep the arrows' aria-expanded right whatever opened the panel (hover, Enter on the word, the arrow)
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(syncButtons);
      realItems.forEach(function (el) { mo.observe(el, { attributes: true, attributeFilter: ['class'] }); });
    }
    var open = function (i) {
      place(i);
      realItems.forEach(function (el, j) { if (j !== i && el.classList.contains('navigation__item--show-children')) el.dispatchEvent(new Event('mouseleave')); });
      realItems[i].dispatchEvent(new Event('mouseenter'));
      realItems[i].dataset.vtOpenedAt = String(Date.now());
    };
    var close = function (i) { if (isOpen(i)) realItems[i].dispatchEvent(new Event('mouseleave')); };
    var closeAll = function () { realItems.forEach(function (_, i) { close(i); }); };
    var firstLink = function (i) { var p = panelOf(i); return p && p.querySelector('a[href], button:not([disabled])'); };

    proxyItems.forEach(function (item, i) {
      item.addEventListener('mouseenter', function () { place(i); });
      var btn = item.querySelector('.vt-dd-toggle');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        // a mouse that just opened it by hovering should not close it again with the same click
        var justOpened = Date.now() - (parseInt(realItems[i].dataset.vtOpenedAt, 10) || 0) < 600;
        if (isOpen(i) && !(e.detail > 0 && justOpened)) close(i);
        else if (!isOpen(i)) open(i);
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || (e.key === 'Tab' && !e.shiftKey && isOpen(i))) {
          if (!isOpen(i)) open(i);
          var target = firstLink(i);
          if (target) { e.preventDefault(); window.setTimeout(function () { target.focus(); }, isOpen(i) ? 0 : 60); }
        }
      });
    });
    // hover opens set the timestamp too (so a click right after the hover keeps it open)
    realItems.forEach(function (el) {
      if ('MutationObserver' in window) {
        new MutationObserver(function () {
          if (el.classList.contains('navigation__item--show-children') && !el.dataset.vtWasOpen) el.dataset.vtOpenedAt = String(Date.now());
          el.dataset.vtWasOpen = el.classList.contains('navigation__item--show-children') ? '1' : '';
        }).observe(el, { attributes: true, attributeFilter: ['class'] });
      }
    });

    // inside a panel: Esc closes (focus back to its arrow), Tab past the last link goes to the next menu word
    realItems.forEach(function (el, i) {
      var panel = panelOf(i);
      if (!panel) return;
      panel.addEventListener('keydown', function (e) {
        var btn = proxyItems[i].querySelector('.vt-dd-toggle') || proxyItems[i].querySelector('.navigation__link');
        if (e.key === 'Escape') {
          e.preventDefault();
          close(i);
          if (btn) btn.focus();
          return;
        }
        if (e.key !== 'Tab') return;
        var links = Array.prototype.filter.call(panel.querySelectorAll('a[href], button:not([disabled])'), function (a) { return a.offsetParent !== null; });
        if (!links.length) return;
        if (!e.shiftKey && document.activeElement === links[links.length - 1]) {
          var next = proxyItems[i + 1] && proxyItems[i + 1].querySelector('.navigation__link');
          if (next) { e.preventDefault(); close(i); next.focus(); }
        } else if (e.shiftKey && document.activeElement === links[0]) {
          e.preventDefault();
          if (btn) btn.focus();
        }
      });
    });
    // Esc anywhere in the header, click outside
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var i = realItems.findIndex(function (el) { return el.classList.contains('navigation__item--show-children'); });
      if (i < 0) return;
      close(i);
      if (proxy.contains(document.activeElement)) return;
      var btn = proxyItems[i].querySelector('.vt-dd-toggle');
      if (btn && mainNav.contains(document.activeElement)) btn.focus();
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('#proxy-nav, #main-nav .navigation__tier-2-container')) return;
      closeAll();
    });
  }

  /* ---- announcement bar: arrows go round both ways, pause on hover as well as focus -------------- */
  function initAnnouncements() {
    var bar = document.querySelector('announcement-bar');
    if (!bar || !html.classList.contains('vt-r10-hdr')) return;
    var items = bar.querySelectorAll('.announcement');
    if (items.length < 2) return;
    var middle = bar.querySelector('.announcement-bar__middle');
    // Symmetry's "previous" from the first message went to the second one; here it goes to the last one
    bar.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.announcement-button');
      if (!btn || typeof bar.setCurrentAnnouncement !== 'function') return;
      e.stopPropagation();
      var n = items.length;
      var cur = bar.currentAnnouncement || 0;
      bar.setCurrentAnnouncement(btn.classList.contains('announcement-button--previous') ? (cur - 1 + n) % n : (cur + 1) % n);
      if (bar.pauseAnnouncements) bar.pauseAnnouncements();
      // the new message is read out once after a button press (not while it changes by itself)
      var live = bar.querySelector('.announcement-bar__announcements');
      if (live) {
        live.setAttribute('aria-live', 'polite');
        window.setTimeout(function () { live.removeAttribute('aria-live'); }, 1500);
      }
    }, true);
    if (middle && bar.pauseAnnouncements && bar.playAnnouncements) {
      var paused = false;
      middle.addEventListener('mouseenter', function () { paused = true; bar.pauseAnnouncements(); });
      middle.addEventListener('mouseleave', function () {
        if (!paused || middle.contains(document.activeElement)) return;
        paused = false;
        bar.pauseAnnouncements();
        bar.playAnnouncements();
      });
    }
    // people who ask for less motion: no automatic changes (the arrows still work)
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches && bar.pauseAnnouncements) {
      bar.playAnnouncements = function () {};
      bar.pauseAnnouncements();
    }
  }

  /* ---- thin olive loading line when she goes to another page ------------------------------------ */
  function initLoadLine() {
    var line = document.querySelector('.vt-loadline');
    if (!line) return;
    var timer = 0;
    var start = function () {
      line.classList.remove('is-done');
      line.classList.add('is-on');
      window.clearTimeout(timer);
      timer = window.setTimeout(stop, 12000); // never stays on (a download, a link a script handled late)
    };
    var stop = function () {
      if (!line.classList.contains('is-on')) return;
      line.classList.remove('is-on');
      line.classList.add('is-done');
      window.setTimeout(function () { line.classList.remove('is-done'); }, 600);
    };
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || a.target === '_blank' || a.hasAttribute('download') || a.getAttribute('href').charAt(0) === '#') return;
      var url;
      try { url = new URL(a.href, location.href); } catch (err) { return; }
      if (url.origin !== location.origin || /^(mailto|tel|javascript):/i.test(a.getAttribute('href'))) return;
      if (url.pathname === location.pathname && url.search === location.search && url.hash) return;
      // links that open drawers / panels are handled by scripts: only start when the page really leaves
      window.setTimeout(function () { if (!e.defaultPrevented) start(); }, 0);
    });
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || e.defaultPrevented || (f.method || '').toLowerCase() === 'post') return;
      window.setTimeout(function () { if (!e.defaultPrevented) start(); }, 0);
    });
    window.addEventListener('pageshow', stop);
    window.addEventListener('pagehide', function () { window.setTimeout(stop, 0); });
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') window.setTimeout(stop, 4000); });
  }

  /* ---- recently viewed on empty search results and on "page not found" --------------------------- */
  function initRecentEmpty() {
    var box = document.querySelector('[data-vt-r10-recent]');
    var core = window.vtCore;
    if (!box || !core || !core.fetchProduct) return;
    var handles = core.readList(core.keys.recent).slice(0, 8);
    if (!handles.length) return;
    var list = box.querySelector('ul');
    Promise.all(handles.map(core.fetchProduct)).then(function (products) {
      var out = products.filter(Boolean).map(function (p) {
        var img = p.featured_image ? core.imageUrl(p.featured_image, 360) : '';
        return '<li><a class="vt-r10-recent__link" href="' + core.esc(core.route('products/' + p.handle)) + '">' +
          (img ? '<img class="vt-r10-recent__img" src="' + core.esc(img) + '" alt="" width="180" height="225" loading="lazy">' : '<span class="vt-r10-recent__img" aria-hidden="true"></span>') +
          '<span class="vt-r10-recent__name">' + core.esc(p.title) + '</span>' +
          '<span class="vt-r10-recent__price">' + core.esc(core.formatMoney(p.price)) + '</span></a></li>';
      }).join('');
      if (!out || !list) return;
      list.innerHTML = out;
      box.hidden = false;
    });
  }

  onReady(function () {
    [initDropdowns, initAnnouncements, initLoadLine, initRecentEmpty].forEach(function (fn) {
      try { fn(); } catch (e) { if (window.console) console.warn('vt-r10', fn.name, e); }
    });
  });
})();
